export default __webpack_public_path__ + "static/media/ZK830.b9de5ba6.png";